import React, { ReactNode } from 'react';

import styles from './CalendarPanel.module.scss';

type CalendarPanelProps = {
  children: ReactNode;
};

export const CalendarPanel = ({ children }: CalendarPanelProps) => {
  return <div className={styles.calendarPanel}>{children}</div>;
};
